import React from 'react';

const Loading = ({ isLoading, timedOut, pastDelay, error }) => {
    if (error) {
        return <div>Error! Component failed to load</div>;
    }
    if (isLoading) {
        if (timedOut) {
            return <div>Loader timed out!</div>;
        }
        if (pastDelay) {
            return <div>...Loading...</div>;
        }
        return <div>...Loading...</div>; // or return null;
    }
    return null; // Render nothing if not loading and no error
};

export default Loading;
